export default __webpack_public_path__ + "static/media/like.cd3e8273.svg";